import React from "react";
import { fetchAttachmentURL, getInlineImage } from "../../API/api";
import styles from "./AttachmentBoxStyles.module.css";

export default function NewAttachmentBox({ attachment }) {
  // console.log("attachment", attachment)
  const downloadAttachment = (file) => {
    console.log("file",file)
    const data = [file];
      let payload = {
          name: file,
        };
        console.log("file",payload)
        if(attachment?.includes(".jpeg") ||
        attachment?.includes(".jpg") ||
        attachment?.includes(".png") ||
        attachment?.includes(".JPEG") ||
        attachment?.includes(".JPG") ||
        attachment?.includes(".PNG")){
             fetchAttachmentURL(payload)
               .then((res) => {
                 if (!res) return;
                 const { src, name } = res.data.data;
             
                 fetch(src)
                   .then((res1) => res1.blob())
                   .then((blob) => {
                     const a = document.createElement("a");
                     a.href = URL.createObjectURL(blob);
                     a.download = name || "download";
                     a.style.display = "none"; // make sure it doesn't flash on screen
                     document.body.appendChild(a); // required for Firefox
                     a.click();
                     document.body.removeChild(a); // clean up
                     URL.revokeObjectURL(a.href); // release memory
                   });
               })
               .catch((err) => {
                 console.error("Download error:", err);
               });
        }
        else{
          // console.log("value")
          // fetchAttachmentURL(payload)
          // .then((res) => {
          //   if (res===undefined) return;
          //   var response = res.data.data;
          //       var aTag = document.createElement("a");
          //       aTag.setAttribute("href", response.objectUrl);
          //       aTag.setAttribute("download", response.name);
          //       aTag.click();
          // })
          // .catch((err) => {});
          getInlineImage(data)
      .then((res) => {
        if (!res || !res.data || !res.data.data) return;
  
        const keys = Object.keys(res.data.data);
        const s3Link = res.data.data[keys[0]];
  
        // Create a hidden anchor element to trigger the download
        const a = document.createElement("a");
        a.href = s3Link;
        a.download = file; // Optional: set filename
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((err) => {
        console.error("Failed to fetch file:", err);
      });
        }
  

  };
  const downloadAttachments = (file) => {
    let data = [file];
  
    getInlineImage(data)
      .then((res) => {
        if (!res || !res.data || !res.data.data) return;
  
        const keys = Object.keys(res.data.data);
        const s3Link = res.data.data[keys[0]];
  
        // Create a hidden anchor element to trigger the download
        const a = document.createElement("a");
        a.href = s3Link;
        a.download = file; // Optional: set filename
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((err) => {
        console.error("Failed to fetch file:", err);
      });
  };
  



  const openPreviewAttachment = (file) => {
    let payload = {
      name: file,
    }; 
    fetchAttachmentURL(payload)
      .then((res) => {
        if (res===undefined) return;
        var response = res.data.data;
        if ((file?.includes(".pdf") ||file?.includes(".PDF") || file?.includes(".Pdf")) && !file?.includes(".pdf_")) {
          response.src = response.src.replace(
            "data:null",
            "data:application/pdf"
          );
        } else {
          response.src = response.src.replace("data:null", "data:image/png");
        }
  fetch(response.src).then(function (res1) {
    res1.blob().then(function (blob) {
      window.open(URL.createObjectURL(blob), "_blank");
    });
  });
      })
      .catch((err) => {});
  };

  return (
    <>
      {(attachment?.includes(".pdf") || attachment?.includes(".PDF") || attachment?.includes(".Pdf")) && !attachment?.includes(".pdf_") ? (
        <span className={styles.imageAttachmentContent}>
          <a onClick={() => openPreviewAttachment(attachment)}>
            <span
              className="fa fa-file-pdf-o"
              style={{ color: "#e61a0e", fontSize: "14px", padding: "3px" }}
            ></span>
            {attachment}
          </a>
          <a>
            <span
              className={styles.downloadIcon}
              onClick={() => downloadAttachment(attachment)}
            >
              <i
                className="fa fa-download attachment-download "
                aria-hidden="true"
                style={{ padding: "3px" }}
              ></i>
            </span>
          </a>
        </span>
      ) : null}
      {attachment?.includes(".jpeg") ||
        attachment?.includes(".jpg") ||
        attachment?.includes(".png") ||
        attachment?.includes(".JPEG") ||
        attachment?.includes(".JPG") ||
        attachment?.includes(".PNG") ? (
        <span className={styles.imageAttachmentContent}>
          <a onClick={() => openPreviewAttachment(attachment)}>
            <span
              className="fa fa-file-image-o"
              style={{ color: "#e61a0e", fontSize: "14px", padding: "3px" }}
            ></span>
            {attachment}
          </a>
          <a>
            <span
              className={styles.downloadIcon}
              onClick={() => downloadAttachment(attachment)}
            >
              <i
                className="fa fa-download attachment-download "
                aria-hidden="true"
                style={{ padding: "3px" }}
              ></i>
            </span>
          </a>
        </span>
      ) : null}
      {attachment.includes(".mp4") || attachment.includes(".MP4") || attachment.includes(".mov") || attachment.includes(".MOV") ? (
        <span className={styles.imageAttachmentContent}>
          <a style={{ pointerEvents: "none" }}>
            <span
              className="fa fa-file-video-o"
              style={{ color: "#e61a0e", fontSize: "14px", padding: "3px" }}
            ></span>
            {attachment}
          </a>
        </span>
      ) : null}
      {attachment.includes(".docx") || attachment.includes(".doc") || attachment.includes(".xlsx") || attachment.includes(".ppt") || attachment.includes('.csv') ? (
        <span className={styles.imageAttachmentContent}>
          <a style={{ pointerEvents: "none" }}>
            <span
              className={`${attachment.includes(".docx") || attachment.includes(".doc") ? 'fa fa-file-o' : "fa fa-file-excel-o"}`}
              style={{ color: "#e61a0e", fontSize: "14px", padding: "3px" }}
            ></span>
            {attachment}
          </a>
          <a>
            <span
              className={styles.downloadIcon}
              onClick={() => downloadAttachment(attachment)}
            >
              <i
                className="fa fa-download attachment-download "
                aria-hidden="true"
                style={{ padding: "3px" }}
              ></i>
            </span>
          </a>
        </span>
      ) : null}
    </>
  );
}
